export default "__VITE_ASSET__DaSYR$eX__"